import { useTranslation } from 'react-i18next'

interface ContactarExitoModalProps {
  onClose: () => void
}

export function ContactarExitoModal({ onClose }: ContactarExitoModalProps) {
  const { t } = useTranslation('simulador')

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center p-6"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-black/35"
        onClick={onClose}
      />
      <div className="relative z-[1] flex w-[min(100%,22rem)] flex-col items-center gap-3 rounded-lg bg-white px-8 py-10 text-center shadow-[0_1.5rem_3rem_rgba(13,26,48,0.18)]">
        <div className="h-14 w-14 text-[#27ae60]">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className="h-full w-full"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="m9 12 2 2 4-4" />
          </svg>
        </div>
        <h2 className="m-0 mt-1 text-[1.25rem] font-bold text-text-primary">
          {t('successTitle')}
        </h2>
        <p className="m-0 text-[0.9375rem] leading-normal text-text-muted">
          {t('successDesc')}
        </p>
        <button
          type="button"
          className="mt-3 w-full cursor-pointer rounded-md border-none bg-[#27ae60] px-4 py-3.5 text-[1rem] font-semibold text-white [transition:opacity_0.15s_ease] hover:opacity-[0.88]"
          onClick={onClose}
        >
          {t('successAccept')}
        </button>
      </div>
    </div>
  )
}
